// extracted by mini-css-extract-plugin
export default {"i-frequencies":"styles-module_i-frequencies---GmeJ0","i-cost":"styles-module_i-cost---fUiLA"};